import { number, shape } from 'prop-types';
import React, { Fragment } from 'react';
import { convertTimeToComponents } from './helpers';

function RecipeTime(props) {
  const { prepTime, cookTime } = props;

  const parsedPrepTime = convertTimeToComponents(prepTime);
  const parsedCookTime = convertTimeToComponents(cookTime);

  if (!parsedPrepTime && !parsedCookTime) {
    return null;
  }

  return (
    <Fragment>
      {parsedPrepTime && (
        <p className="Recipe__timeEntry">
          <span className="Recipe__timeLabel">Prep time</span>{' '}
          {parsedPrepTime.humanString}
        </p>
      )}

      {parsedCookTime && (
        <p className="Recipe__timeEntry">
          <span className="Recipe__timeLabel">Cook time</span>{' '}
          {parsedCookTime.humanString}
        </p>
      )}
    </Fragment>
  );
}

RecipeTime.propTypes = {
  cookTime: shape({
    min: number,
    max: number
  }),
  prepTime: shape({
    min: number,
    max: number
  })
};

RecipeTime.defaultProps = {
  cookTime: undefined,
  prepTime: undefined
};

export default RecipeTime;
